import { useOptimizedQuery } from './useOptimizedQuery';
import { supabase } from '@/integrations/supabase/client';
import { logger } from '@/lib/logger';

export const useTeamLeadsData = () => {
  return useOptimizedQuery({
    queryKey: ['team-leads'],
    queryFn: async () => {
      try {
        const { data, error } = await supabase
          .rpc('get_team_lead_users');
        
        if (error) throw error;
        
        // Transform data for consistent format
        return (data || []).map(user => ({
          id: user.id,
          full_name: user.full_name,
          email: user.email,
          avatar_url: user.avatar_url,
          name: user.full_name || user.email || 'Unknown',
        })).sort((a, b) => a.name.localeCompare(b.name));
      } catch (error) {
        logger.error('[useTeamLeadsData] Error fetching team leads:', error);
        return [];
      }
    },
    staleTime: 10 * 60 * 1000, // 10 minutes
    gcTime: 30 * 60 * 1000, // 30 minutes
  });
};
